/* global Config */

import axios from 'axios';
import {serviceConfig} from '../../../config/service-config';

export const separateUniqueRUIDsFromUserEntry = ruidEntryString => {
  const splitRegex = /[\n, ]/; // separate by comma, space, or line break
  return [
    ...new Set(
      ruidEntryString
        .split(splitRegex)
        .map(potentialRUID => potentialRUID.trim())
        .filter(ruid => ruid !== '')
    ),
  ];
};

export const validateRuidsCollection = ruidCollection => {
  const {method, baseUrl, path} = serviceConfig.ASSET_BY_RUID;
  const validDataPackagesCollectorMap = new Map();

  const getPathWithRuidData = ruid => path.replace('{ruid}', ruid);

  return Promise.allSettled(
    ruidCollection.map(ruid => axios[method.toLowerCase()](`${baseUrl}${getPathWithRuidData(ruid)}`))
  ).then(responses => {
    for (let index = 0; index < responses.length; index++) {
      const {status, value} = responses[index];

      // eslint-disable-next-line no-continue
      if (status === 'rejected') continue;

      const currentRUID = ruidCollection[index];
      const {data: fetchedAsset} = value;

      if (!validDataPackagesCollectorMap.has(currentRUID)) {
        const dataPackageToAdd = fetchedAsset.dataPackages.find(dp => dp.dataPackageId === currentRUID);
        validDataPackagesCollectorMap.set(currentRUID, {
          ...dataPackageToAdd,
          asset: {
            ...fetchedAsset,
            dataPackages: [],
          },
        });
      }
    }
    return validDataPackagesCollectorMap;
  });
};

export const massDeleteBatchSize = Config.base.massDpDeleteLimit || 3;

export const convertCamelCaseToWords = text => {
  const result = text.replace(/([A-Z])/g, ' $1');
  return result.charAt(0).toUpperCase() + result.slice(1);
};

export const formatTimeStamp = (unixTimeStamp, options = {}) =>
  new Date(unixTimeStamp).toLocaleDateString('en-us', options);

export const FILL_COLOR = '#314e85';
export const TEXT_COLOR = '#fdfdfc';
export const FILL_COLOR_DISABLED = '#9cb0d7';

export const assetsTableStylesObject = {
  rowCell: {
    border: '1px solid grey',
    backgroundColor: FILL_COLOR,
    color: TEXT_COLOR,
    marginLeft: 5,
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 5,
    paddingBottom: 5,
    borderRadius: 20,
  },
  rowCellDisabled: {
    backgroundColor: FILL_COLOR_DISABLED,
    color: TEXT_COLOR,
    marginLeft: 5,
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 5,
    paddingBottom: 5,
    borderRadius: 20,
  },
  rowDiv: {display: 'flex', alignItems: 'center', width: 'auto', maxWidth: '75%'},
  rowHeader: {marginLeft: 10, color: FILL_COLOR},
  rowHeaderDisabled: {marginLeft: 10, color: FILL_COLOR_DISABLED},
};

export const vcaTypes = ['Ad supported', 'Ad free', 'N/A', 'No VCA defined'];
